import React from 'react';
import { Row, Button, Col, Spinner, Form } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import StoreOrderList from './StoreOrderList.js';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

export function MaterialUIPickers(props) {
    if (props.id == 'date-picker-inline1') {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = new Date(y, m, 1);
        // var firstDay = new Date();
    } else {
        var firstDay = new Date();
    }
    const [selectedDate, setSelectedDate] = React.useState(firstDay);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.setDate(date);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justifyContent="space-around">
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id={props.id}
                    label={props.label}
                    value={selectedDate}
                    onChange={handleDateChange}
                    autoOk={true}
                    maxDate={
                        props.id == 'date-picker-inline2' ? new Date() : ''
                    }
                    KeyboardButtonProps={{
                        'aria-label': 'change date'
                    }}
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
}

class OrdersList extends React.Component {
    _isMounted = false;
    state = {
        storeTag: '',
        backArrow: false,
        fromDate: this.getFormattedDate(new Date()),
        toDate: this.getFormattedDateTo(new Date()),
        flag: 0,
        alert: 0,
        alertMessage: '',
        data: [],
        serveroptions: [],
        search_key: ''
    };

    getFormattedDate(date) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    getFormattedDateTo(date) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        if (this._isMounted) {
            var date = new Date(),
                y = date.getFullYear(),
                m = date.getMonth();
            var firstDay = new Date(y, m, 1);
            this.setState({ fromDate: this.getFormattedDate(firstDay) });
        }
    }

    async searchStoreTag(storeTag) {
        if (this._isMounted) {
            this.setState({ storeTag: storeTag });
        }
        let bodyData = {
            search_key: storeTag,
            search_by: 'StoreTag',
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:
                this.props.role == 'StoreOwners'
                    ? 'StoreOwner'
                    : this.props.role,
            perPage: 10
        };
        await RestServices.SearchStoreTagsMapping(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (StoreTags) => {
                if (this._isMounted) {
                    this.setState({ serveroptions: StoreTags.list, flag: 0 });
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        backArrow: false,
                        flag: 0,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    async loadData() {
        if (this.state.storeTag) {
            if (this._isMounted) {
                this.setState({ flag: 2, alert: 0, alertMessage: '' });
            }
        } else {
            if (this._isMounted) {
                this.setState({
                    flag: 0,
                    alert: 1,
                    alertMessage: 'Please select Store Tag'
                });
            }
        }
    }

    render() {
        return (
            <div>
                <hr />
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                <div>
                    <Row>
                        <Col>
                            <Autocomplete
                                name="storeTag"
                                onInputChange={(event, newInputValue) => {
                                    if (newInputValue.length > 1) {
                                        this.searchStoreTag(newInputValue);
                                    }
                                }}
                                options={this.state.serveroptions.map(
                                    (arr) => arr
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Store Tag"
                                        margin="normal"
                                        variant="outlined"
                                    />
                                )}
                            />
                        </Col>

                        <Col>
                            <MaterialUIPickers
                                id="date-picker-inline1"
                                label="From Date"
                                setDate={(date) => {
                                    this.setState({
                                        fromDate: this.getFormattedDate(date)
                                    });
                                }}
                            />
                        </Col>

                        <Col>
                            <MaterialUIPickers
                                id="date-picker-inline2"
                                label="To Date"
                                setDate={(date) => {
                                    this.setState({
                                        toDate: this.getFormattedDate(date)
                                    });
                                }}
                            />
                        </Col>
                        <Col>
                            <Button
                                onClick={() => {
                                    this.loadData();
                                }}
                                style={{ marginTop: '1.3rem' }}
                            >
                                Fetch
                            </Button>
                        </Col>
                    </Row>
                    <Row></Row>
                </div>

                {this.state.flag > 1 && (
                    <StoreOrderList
                        storeTag={this.state.storeTag}
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                        {...this.props}
                    />
                )}
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(OrdersList);
